import React, { createContext, useContext, useState } from "react";

// Define the shape of your filters
interface Filters {
    routeIds?: string[];
    eventTypes?: string[];
    startDate?: string | null;
    endDate?: string | null;
    // Add other filter fields here if needed
}

// Define the context type using the Filters interface
type FilterContextType = {
    filters: Filters;
    setFilters: React.Dispatch<React.SetStateAction<Filters>>;
};

// Provide a default value that conforms to FilterContextType
const defaultFilterContext: FilterContextType = {
    filters: { routeIds: [] },
    setFilters: () => { },
};

const FilterContext = createContext<FilterContextType>(defaultFilterContext);

interface FilterProviderProps {
    children: React.ReactNode;
}

export const FilterProvider: React.FC<FilterProviderProps> = ({ children }) => {
    const [filters, setFilters] = useState<Filters>({ routeIds: [] });

    return (
        <FilterContext.Provider value={{ filters, setFilters }}>
            {children}
        </FilterContext.Provider>
    );
};

export const useFilters = () => {
    const context = useContext(FilterContext);
    if (!context) {
        throw new Error("useFilters must be used within a FilterProvider");
    }
    return context;
};
